module.exports = __webpack_public_path__ + "static/media/YEBOlogo-notext.649af0ab.jpg";